import * as React from 'react';
import { Link } from 'react-router-dom';

interface dadosCard{
    nome:string,
    cargo:string,
    linkedin:string,
    foto:string
}

const Card = (props:dadosCard) => {
    return(
        <div className="container col-sm-6 col-md-4">
            <div className="card">
                <img className="card-img-top" src={props.foto} alt="Card"/>
                <div className="card-body">
                    <h5 className="card-title">{props.nome}</h5>
                    <p className="card-text">{props.cargo}</p>
                    <Link to={props.linkedin} target="_blank">
                        <i className="fab fa-linkedin-in fa-2x icon roxo-e"></i>
                    </Link>
                </div>
            </div>
        </div>
    );
}
export default Card;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TeamCardComponent.tsx